"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLiveMsg = exports.MicroStatus = exports.BuiltinActionType = exports.BuiltinEventType = exports.Command = void 0;
/**
 * WebSocket 通信指令
 * - 下行：服务端推送数据
 * - 上行：客户端上报数据
 */
var Command;
(function (Command) {
    /* 当前用户信息：下行 */
    Command["SelfUserInfo"] = "SELF_USER_INFO";
    /* 房间信息：下行 */
    Command["RoomInfo"] = "ROOM_INFO";
    /* RTC信息：下行 */
    Command["RTCInfo"] = "RTC_INFO";
    /* 用户列表：下行 */
    Command["UserList"] = "USER_LIST";
    /* 内置消息：下行、上行 */
    Command["BuiltinMsg"] = "BUILTIN_MSG";
    /* 自定义广播事件消息：下行、上行 */
    Command["CustomEvent"] = "CUSTOM_EVENT";
    /* 帧数据同步：下行、上行 */
    Command["KeyframeSync"] = "KEYFRAME_SYNC";
    /* 被踢出房间：下行 */
    Command["UserKickOut"] = "USER_KICK_OUT";
})(Command = exports.Command || (exports.Command = {}));
/**
 * 内置事件类型。
 */
var BuiltinEventType;
(function (BuiltinEventType) {
    /**
     * 变更用户状态。
     */
    BuiltinEventType["UserChange"] = "user_change";
    /**
     * 变更房间状态。
     */
    BuiltinEventType["RoomChange"] = "room_change";
})(BuiltinEventType = exports.BuiltinEventType || (exports.BuiltinEventType = {}));
/**
 * 内置事件行为类型。
 */
var BuiltinActionType;
(function (BuiltinActionType) {
    /**
     * 修改麦克风状态。
     */
    BuiltinActionType["UserMicroStatus"] = "change_micro_status";
    /**
     * 同步当前用户状态：客户端麦克风状态已经修改成功，通知服务端
     */
    BuiltinActionType["UserMicroStatusSync"] = "sync_micro_status";
    /**
     * 调整某些用户的权限。
     */
    BuiltinActionType["UserPermission"] = "change_permission";
    /**
     * 用户状态发生改变。
     */
    BuiltinActionType["UserStatus"] = "change_status";
    /**
     * 更新用户信息。
     */
    BuiltinActionType["UserInfo"] = "change_info";
    /**
     * 关闭房间。
     */
    BuiltinActionType["RoomClose"] = "close";
})(BuiltinActionType = exports.BuiltinActionType || (exports.BuiltinActionType = {}));
/**
 * 麦克风状态。
 */
var MicroStatus;
(function (MicroStatus) {
    MicroStatus["OPEN"] = "OPEN";
    MicroStatus["CLOSE"] = "CLOSE";
})(MicroStatus = exports.MicroStatus || (exports.MicroStatus = {}));
/**
 * 解析下后端数据格式。
 * @param jsonTxt - JSON序列化后的文本。
 * @returns false 标识解析失败；解析成功返回 {@link LiveMsg} 实例。
 */
function parseLiveMsg(jsonTxt) {
    try {
        var msg = JSON.parse(jsonTxt);
        var resMsg_1 = {
            code: msg.code,
            message: msg.message,
            command: msg.command,
            roomCode: msg.room_code,
            appID: msg.app_id,
            requestId: msg.request_id,
            frontRequestId: msg.front_request_id,
            triggerUserID: msg.trigger_user_id,
            data: msg.data || {},
        };
        var undefinedKeys = Object.keys(resMsg_1).filter(function (key) { return resMsg_1[key] === undefined; });
        if (undefinedKeys.length > 0) {
            console.warn("\u63A8\u9001\u6570\u636E\u683C\u5F0F\u5F02\u5E38\uFF1A" + undefinedKeys.join(' ') + " \u503C\u4E0D\u5B58\u5728\uFF01");
        }
        return resMsg_1;
    }
    catch (error) {
        // notcare? 过滤掉所有不符合规范的数据
        return false;
    }
}
exports.parseLiveMsg = parseLiveMsg;
//# sourceMappingURL=LiveMsg.js.map